export enum ETipoFormaEntrega {
    RetiradaLocal = 1,
    EntregaPropria = 2,
    Transportadora = 3,
    FRENET = 4,
    TotalExpress = 5,
    Loggi = 6,
    Correios = 7,
}
